import React from "react";
import styles from './styles.module.css';

const TAX_LABELS = {
    iss:    'ISS',
    irrf:   'IRRF',
    csll:   'CSLL',
    cofins: 'COFINS',
    pis:    'PIS',
};

function CardNotes({ createdInvoice }) {
    if (!createdInvoice) return null;

    const services  = createdInvoice.services  || [];
    const taxes     = createdInvoice.taxes     || {};
    const recipient = createdInvoice.recipient || {};

    // Filtra apenas impostos com valor diferente de 0
    const activeTaxes = Object.entries(TAX_LABELS).filter(
        ([key]) => taxes[key] != null && Number(taxes[key]) !== 0
    );

    const fmt = (v) =>
        Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return (
        <div className={styles.container}>

            {/* ── Info da nota ── */}
            <div className={styles.section}>
                <h4 className={styles.sectionTitle}>Nota</h4>
                <div className={styles.infoGrid}>
                    <span className={styles.infoLabel}>Número</span>
                    <span className={styles.infoValue}>{createdInvoice.number}</span>

                    <span className={styles.infoLabel}>Status</span>
                    <span className={`${styles.statusBadge} ${styles[createdInvoice.status]}`}>
                        {createdInvoice.status?.charAt(0).toUpperCase() + createdInvoice.status?.slice(1)}
                    </span>

                    <span className={styles.infoLabel}>Emissão</span>
                    <span className={styles.infoValue}>
                        {new Date(createdInvoice.dateIssue).toLocaleDateString('pt-BR')}
                    </span>
                </div>
            </div>

            {/* ── Cliente ── */}
            <div className={styles.section}>
                <h4 className={styles.sectionTitle}>Cliente</h4>
                <div className={styles.infoGrid}>
                    <span className={styles.infoLabel}>Nome</span>
                    <span className={styles.infoValue}>{recipient.name || '—'}</span>

                    {recipient.cpfCnpj && <>
                        <span className={styles.infoLabel}>CPF/CNPJ</span>
                        <span className={styles.infoValue}>{recipient.cpfCnpj || '—'}</span>
                    </>}

                    {recipient.address && <>
                        <span className={styles.infoLabel}>Endereço</span>
                        <span className={styles.infoValue}>{recipient.address || '—'}</span>
                    </>}

                    {recipient.phone && <>
                        <span className={styles.infoLabel}>Telefone</span>
                        <span className={styles.infoValue}>{recipient.phone}</span>
                    </>}
                </div>
            </div>

            {/* ── Serviços ── */}
            <div className={styles.section}>
                <h4 className={styles.sectionTitle}>Serviços</h4>
                {services.length > 0 ? (
                    <div className={styles.servicesList}>
                        {services.map((service, index) => {
                            const subtotal = (service.amount || 0) * (service.valueUnit || 0);
                            return (
                                <div key={index} className={styles.serviceItem}>
                                    <div className={styles.serviceTop}>
                                        <span className={styles.serviceDesc}>{service.description}</span>
                                        <span className={styles.serviceSubtotal}>{fmt(subtotal)}</span>
                                    </div>
                                    <div className={styles.serviceMeta}>
                                        <span>Qtd: <strong>{service.amount}</strong></span>
                                        <span>×</span>
                                        <span>Unit: <strong>{fmt(service.valueUnit)}</strong></span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p className={styles.empty}>Sem serviços cadastrados.</p>
                )}
            </div>

            {/* ── Impostos (só os != 0) ── */}
            {activeTaxes.length > 0 && (
                <div className={styles.section}>
                    <h4 className={styles.sectionTitle}>Impostos</h4>
                    <div className={styles.taxGrid}>
                        {activeTaxes.map(([key, label]) => (
                            <div key={key} className={styles.taxItem}>
                                <span className={styles.taxLabel}>{label}</span>
                                <span className={styles.taxValue}>{fmt(taxes[key])}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* ── Resumo ── */}
            <div className={styles.section}>
                <h4 className={styles.sectionTitle}>Resumo</h4>
                <div className={styles.totalRow}>
                    <span className={styles.totalLabel}>Valor Total</span>
                    <span className={styles.totalValue}>{fmt(createdInvoice.totalValue)}</span>
                </div>
            </div>

            {/* ── Observações ── */}
            {createdInvoice.obs && (
                <div className={styles.section}>
                    <h4 className={styles.sectionTitle}>Observações</h4>
                    <p className={styles.obs}>{createdInvoice.obs}</p>
                </div>
            )}

        </div>
    );
}

export default CardNotes;